/* eslint-disable import/no-anonymous-default-export */
import { Layout, Typography } from "antd";
import React from "react";
import styled from "styled-components";
import Sider from "antd/lib/layout/Sider";
import NavMenu, { MenuItem } from "../../common/components/NavMenu";
import { useNavigate } from "react-router-dom";
import { FileSearchOutlined, ProfileOutlined } from "@ant-design/icons";
import BrandBar from "../../common/components/BrandBar";

const StyledLayout = styled(Layout)`
  height: 100%;
`;

const StyledBody = styled(Layout)`
  margin-left: 250px;
  width: calc(100% - 250px);
`;

const StyledContent = styled.div`
  padding: 2rem;
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 4rem;
`;

const StyledSider = styled(Sider)`
  background-color: #212121;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2;
  height: 100%;
  overflow: auto;

  flex: 0 0 250px !important;
  max-width: 240px !important;
  min-width: 230px !important;
  width: 250px !important;
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  background: var(--primary-color);
  justify-content: center;
  position: sticky;
  top: 0;
  padding: 0.4rem;
  img {
    width: auto;
  }
`;

interface MainLayoutProps {
  children: React.ReactNode;
  title?: string;
  maxContentWidth?: number;
}

export default (props: MainLayoutProps) => {
  const navigate = useNavigate();
  const menuItems: MenuItem[] = [
    {
      title: "Infracciones",
      key: "DescargosJuzgado",
      selectedPath: "/juzgado-consulta",
      // TODO: Cambiar permisos
      permissions: ["InfraccionRadar.*", "ConfiguracionJuzgado.*"],
      onClick: () => navigate("/juzgado-consulta"),
    },
    /* {
      title: "Libre de deuda",
      key: "LibreDeuda",
      selectedPath: "/juzgado/libre-deuda",
      // TODO: Cambiar permisos
      permissions: ["InfraccionRadar.*", "ConfiguracionJuzgado.*"],
      onClick: () => navigate("/juzgado/libre-deuda"),
    } */
  ];

  return (
    <StyledLayout>
      <StyledSider>
        <TitleContainer>
          <BrandBar/>
        </TitleContainer>
        <NavMenu showBrandBar={false} items={menuItems} />
      </StyledSider>
      <StyledBody>
        <StyledContent>
          {props.title && (
            <Typography.Title level={4}>{props.title}</Typography.Title>
          )}
          {props.children}
        </StyledContent>
      </StyledBody>
    </StyledLayout>
  );
};

//<div style={{maxWidth:props.maxContentWidth ?? 1024,margin:'auto'}}></div>
